import React from 'react';
import BrandingPanel from '../components/BrandingPanel';
import Login from '../components/LoginForm';

const LoginPage: React.FC = () => (
  <div className="login-page">
    <BrandingPanel />
    <div className="login-form-area">
      <Login />
    </div>
  </div>
);

export default LoginPage;
